/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import test from './modules/test'
import call from './modules/call-center'
import login from './modules/login'
import review from './modules/review'
import api from './modules/api'

import getters from './getters'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isEngnineer: false
  },
  modules: {
    test,
    call,
    login,
    review,
    api
  },
  getters,
  mutations: {
    ['IS_ENGNINEER'](state, isEngnineer) {
      state.isEngnineer = isEngnineer
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js